import api_adm from "./api";
const endpoint = "volontariat/CV";

export const AssociationMembreCVService = {
  async listCVMembre(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
